export default "__VITE_ASSET__P9YVWFG8__"